import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapStringTo, Nullable } from "../base-types";

@JsonObject()
export class FetchSetting {
    @JsonProperty("file_provider_name")
    fileProviderName: string;

    @JsonProperty("location_name")
    locationName: string;

    @JsonProperty("allowed_types")
    @JsonElementType(String)
    allowedTypes: Array<string>;

    @JsonProperty("allowed_web_locations")
    @JsonElementType(String)
    allowedWebLocations: Array<string>;

    @JsonProperty("allowed_file_locations")
    @JsonElementType(String)
    allowedFileLocations: Array<string>;

    @JsonProperty("allowed_azure_locations")
    @JsonElementType(String)
    allowedAzureLocations: Array<string>;

    @JsonProperty("allowed_extensions")
    @JsonElementType(String)
    allowedExtensions: Array<string>;

    @JsonProperty("disallowed_extensions")
    @JsonElementType(String)
    disallowedExtensions: Array<string>;

    @JsonProperty("delete_when_done")
    deleteWhenDone: MapStringTo<Nullable<boolean>>;
}
